<template>
  <AddUser />
</template>

<script>
import AddUser from '../../../components/dadban/user/AddUserList.vue'
import appConfig from '@/app.config'

export default {
  page: {
    title: 'افزودن کاربر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    AddUser,
  },
}
</script>

<style scoped lang="scss"></style>
